import Swiper from "swiper/bundle";

export const pageLocationsCafe = () => {
  const $pageLocationsCafe = document.querySelector(
    "section.page-locations-cafe"
  );
  if ($pageLocationsCafe) {
    const $pageLocationsCafeOther = $pageLocationsCafe.querySelector(
      ".page-locations-cafe__other"
    );
    const $pageLocationsCafeSwiper =
      $pageLocationsCafeOther?.querySelector(".other__swiper");

    if ($pageLocationsCafeSwiper) {
      const swiperConfig = {
        slidesPerView: 1.2,
        loop: false,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
        },
      };
      const swiperObject = new Swiper($pageLocationsCafeSwiper, swiperConfig);
    }
  }
};

export default pageLocationsCafe;
